import { Outlet } from "react-router-dom";
import WizardProvider from "../contexts/wizard.context";
import { MatchMakerRoutes } from "../routes/MatchMakerRoutes";
import { MatchMakerWizard } from "../components/match-maker/MatchMakerWizard";

export const MatchMaker: React.FC = () => {
    return (
        <WizardProvider>
            <MatchMakerWizard />
            <MatchMakerRoutes />
            <Outlet />
        </WizardProvider>
    );
};
